import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import config from '@/config'
import 'font-awesome/css/font-awesome.css'
import ru from 'vuetify/es5/locale/ru'
// import 'material-design-icons/iconfont/material-icons.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            dark: config.dark,
            light: config.light,
        }
    },
    lang: {
        locales: { ru },
        current: 'ru'
    },
    iconfont: 'mdi'
});
